import _ from 'lodash';

export const selectSignedRecordings = ({ transcripts }) =>
  _.get(transcripts, 'signedUrls.recordings', []);
export const selectIsFetchingSignedRecordings = ({ transcripts }) =>
  _.get(transcripts, 'signedUrls.isFetching', false);



// WEBPACK FOOTER //
// ./redux/selectors/transcripts.js